/** 무한 목록은 tRPC 훅이 아닌 TanStack 훅이라 캐시 키를 직접 둔다. 무효화(use-invalidate-reviews)와 같은 접두를 쓴다. */
export const PRODUCT_REVIEWS_KEY = 'product-reviews';
export const MY_REVIEWS_KEY = 'my-reviews';
